import * as cartApi from '../../api/cart-api';
import { IErrorResult, IResult } from '../../models/result-models';
import {
    apiCallError,
    beginApiCall,
    endApiCall,
} from '../api/api-status-action';
import {
    ICartItemInfo,
    IUpdateItemQuantityRequest,
} from '../../models/pro-sites';
import externalSite from '../../global-functions';
import { CartType } from '../../models/cart-type-enum';
import { loadSession } from '../session/session-actions';

export const CLEAR_SAVED_CART = 'CLEAR_SAVED_CART';

export const LOAD_SAVED_CART_SUCCESS = 'LOAD_SAVED_CART_SUCCESS';
export const LOAD_SAVED_CART_ERROR = 'LOAD_SAVED_CART_ERROR';

export const MOVE_PRIMARY_TO_SAVED_SUCCESS = 'MOVE_PRIMARY_TO_SAVED_SUCCESS';
export const MOVE_PRIMARY_TO_SAVED_ERROR = 'MOVE_PRIMARY_TO_SAVED_ERROR';

export const MOVE_SAVED_TO_PRIMARY_SUCCESS = 'MOVE_SAVED_TO_PRIMARY_SUCCESS';
export const MOVE_SAVED_TO_PRIMARY_ERROR = 'MOVE_SAVED_TO_PRIMARY_ERROR';

export const UPDATE_ITEM_QUANTITY_ERROR = 'UPDATE_ITEM_QUANTITY_ERROR';
export const CLEAR_CART_ERROR = 'CLEAR_CART_ERROR';

export const clearSavedCart = () => ({
    type: CLEAR_SAVED_CART,
});

export const loadSavedCartSuccess = (payload: IResult<ICartItemInfo[]>) => ({
    type: LOAD_SAVED_CART_SUCCESS,
    payload,
});

export const loadSavedCartError = (payload: IErrorResult) => ({
    type: LOAD_SAVED_CART_ERROR,
    payload,
});

export const movePrimaryToSavedSuccess = (
    payload: IResult<ICartItemInfo[]>
) => ({
    type: MOVE_PRIMARY_TO_SAVED_SUCCESS,
    payload,
});

export const movePrimaryToSavedError = (payload: IErrorResult) => ({
    type: MOVE_PRIMARY_TO_SAVED_ERROR,
    payload,
});

export const moveSavedToPrimarySuccess = (
    payload: IResult<ICartItemInfo[]>
) => ({
    type: MOVE_SAVED_TO_PRIMARY_SUCCESS,
    payload,
});

export const moveSavedToPrimaryError = (payload: IErrorResult) => ({
    type: MOVE_SAVED_TO_PRIMARY_ERROR,
    payload,
});

export const updateItemQuantityError = (payload: IErrorResult) => ({
    type: UPDATE_ITEM_QUANTITY_ERROR,
    payload,
});

export const clearCartError = (payload: IErrorResult) => ({
    type: CLEAR_CART_ERROR,
    payload,
});

// Thunks
export const loadSavedCart = () => {
    return async (dispatch: any) => {
        try {
            const result = await cartApi.getSavedCart();
            if (result.ok) {
                dispatch(loadSavedCartSuccess(result));
            } else {
                dispatch(
                    loadSavedCartError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const movePrimaryToSaved = (lineItemId: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await cartApi.moveItemFromPrimaryCartToSavedCart(
                lineItemId
            );
            if (result.ok) {
                externalSite.updateCart();
                dispatch(movePrimaryToSavedSuccess(result));
            } else {
                dispatch(
                    movePrimaryToSavedError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const moveSavedToPrimary = (lineItemId: string) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await cartApi.moveItemFromSavedCartToPrimaryCart(
                lineItemId
            );
            if (result.ok) {
                externalSite.updateCart();
                dispatch(moveSavedToPrimarySuccess(result));
            } else {
                dispatch(
                    moveSavedToPrimaryError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const updateQuantity = (request: IUpdateItemQuantityRequest) => {
    return async (dispatch: any) => {
        try {
            const result = await cartApi.updateItemQuantity(request);
            if (result.ok) {
                externalSite.updateCart();
            } else {
                dispatch(
                    updateItemQuantityError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error, 'UPDATE_CART_ITEM_QUANTITY'));
            throw error;
        }
    };
};

export const clear = (cartType: CartType) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall('CLEAR_CART'));
            const result = await cartApi.clear(cartType);
            if (result.ok) {
                if (cartType === CartType.Primary) {
                    dispatch(loadSession());
                    externalSite.updateCart();
                }
                if (cartType === CartType.Saved) {
                    dispatch(loadSavedCart());
                }

                dispatch(endApiCall('CLEAR_CART'));
            } else {
                dispatch(
                    clearCartError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error, 'CLEAR_CART'));
            throw error;
        }
    };
};
